import {
  CLEAR_CHAT_SESSION,
  CLEAR_CONTINUOUS_CHAT_SESSION,
  NEW_CHAT_SESSION,
  SET_CHAT_SESSION_ID,
  SET_CHAT_SESSION_STORAGE_KEY,
  SET_CONTINUOUS_CHAT_SESSION_ID,
  SET_CONTINUOUS_CHAT_SESSION_STORAGE_KEY,
} from '../actions/types';
import type { SessionActions } from '../actions/types';
import type { SessionState } from '../types';
import { createReducer } from '../utils/createReducer';

const initialState = {
  chatSessionId: undefined,
  chatSessionStorageKey: undefined,
  continuousChatSessionId: undefined,
  continuousChatSessionStorageKey: undefined,
};

const sessionStateReducer = {
  [NEW_CHAT_SESSION]: (state: SessionState) => {
    return {
      ...state,
      chatSessionId: undefined,
      chatSessionStorageKey: undefined,
    };
  },
  [CLEAR_CHAT_SESSION]: (state: SessionState) => ({
    ...state,
    chatSessionId: undefined,
    chatSessionStorageKey: undefined,
  }),
  [CLEAR_CONTINUOUS_CHAT_SESSION]: (state: SessionState) => ({
    ...state,
    continuousChatSessionId: undefined,
    continuousChatSessionStorageKey: undefined,
  }),
  [SET_CHAT_SESSION_ID]: (state: SessionState, { chatSessionId }: SessionState) => ({
    ...state,
    chatSessionId: chatSessionId === '' ? undefined : chatSessionId,
  }),
  [SET_CHAT_SESSION_STORAGE_KEY]: (state: SessionState, chatSessionStorageKey: string) => ({
    ...state,
    chatSessionStorageKey,
  }),
  [SET_CONTINUOUS_CHAT_SESSION_ID]: (state: SessionState, { continuousChatSessionId }: SessionState) => ({
    ...state,
    continuousChatSessionId: continuousChatSessionId === '' ? undefined : continuousChatSessionId,
  }),
  [SET_CONTINUOUS_CHAT_SESSION_STORAGE_KEY]: (state: SessionState, continuousChatSessionStorageKey: string) => ({
    ...state,
    continuousChatSessionStorageKey,
  }),
};

export default (state = initialState, action: SessionActions) => createReducer(sessionStateReducer, state, action);
